import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

export function adTickerSpaceSx(visible) {
  if (!visible) return { "--ad-ticker-space": "0px" };
  return {
    "--ad-ticker-space": "56px",
    "@media (min-width:900px)": { "--ad-ticker-space": "72px" },
  };
}

function tickerItems(ads) {
  return (ads || []).filter((ad) => ad?.tickerDescription || ad?.tickerLogoUrl);
}

function scrollSeconds(text) {
  const length = String(text || "").length;
  return Math.min(28, Math.max(10, Math.ceil(length / 4)));
}

const PublicAdTicker = ({ ads = [], hidden = false }) => {
  const items = tickerItems(ads);
  const signature = items
    .map((ad) => `${ad.id}:${ad.tickerDescription || ""}:${ad.tickerLogoUrl ? "1" : "0"}`)
    .join("|");
  const [cycle, setCycle] = useState(0);

  useEffect(() => {
    setCycle(0);
  }, [signature]);

  const ad = items.length ? items[cycle % items.length] : null;
  const description = ad?.tickerDescription || "";

  const adId = ad?.id || null;

  useEffect(() => {
    if (!adId || items.length < 2) return undefined;
    const waitMs = description ? scrollSeconds(description) * 1000 : 8000;
    const timer = setTimeout(() => {
      setCycle((current) => current + 1);
    }, waitMs);
    return () => clearTimeout(timer);
  }, [adId, description, items.length]);

  if (!ad) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 4500,
        height: { xs: 56, md: 72 },
        visibility: hidden ? "hidden" : "visible",
        display: "flex",
        alignItems: "center",
        backgroundColor: "#183059",
        overflow: "hidden",
      }}
    >
      {ad.tickerLogoUrl ? (
        <Box
          sx={{
            flex: "0 0 auto",
            height: "100%",
            display: "flex",
            alignItems: "center",
            px: 1.5,
            backgroundColor: "#FFFFFF",
          }}
        >
          <Box
            component="img"
            src={ad.tickerLogoUrl}
            alt=""
            sx={{ height: { xs: 36, md: 48 }, width: "auto", maxWidth: 140, objectFit: "contain" }}
          />
        </Box>
      ) : null}
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          height: "100%",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          containerType: "inline-size",
        }}
      >
        {description ? (
          <Box
            key={`${ad.id}-${cycle}`}
            sx={{
              display: "flex",
              width: "max-content",
              animation: `adTickerLtr ${scrollSeconds(description)}s linear infinite`,
              "@keyframes adTickerLtr": {
                from: { transform: "translateX(-50%)" },
                to: { transform: "translateX(0)" },
              },
            }}
          >
            {[0, 1].map((copy) => (
              <Typography
                key={copy}
                component="span"
                sx={{
                  whiteSpace: "nowrap",
                  color: "#F9E719",
                  fontFamily: "Roboto, sans-serif",
                  fontWeight: 700,
                  fontSize: { xs: "1.15rem", md: "1.75rem" },
                  lineHeight: 1,
                  px: 4,
                  minWidth: "100cqi",
                }}
              >
                {description}
              </Typography>
            ))}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default PublicAdTicker;
